import React from 'react'
import { useSelector } from 'react-redux'

import CategoryList from '@/features/market/market-category-list'
import MarketShareFollow from '@/features/market/share-follow'
import QuestionFooter from '@/features/market/question-footer'
import QuestionHeader from '@/features/market/question-header'
import { selectActiveLanguage } from '@/store/app'
import { useActiveCurrency, useCurrencies } from '@/hooks'
import { usesButtonsDisplay } from '@/features/market/utils/marketType'
import { isSportsEvent } from '@/features/market/utils/sportsEvent'

/**
 * Title, stats and share/follow controls for the desktop market page.
 *
 * Rendered by the page rather than the market card so the row can span the
 * full grid width, leaving the share/follow controls flush with the page edge
 * and the bet pad starting below it.
 */
const MarketPageHeader = ({ question, categories, showSummary = false }) => {
  const locale = useSelector(selectActiveLanguage())
  const currencies = useCurrencies().currencies
  const activeCurrency = useActiveCurrency()
  const isRealMoney = activeCurrency && activeCurrency.id !== currencies.OOM.id

  if (!question) return null

  return (
    <div className="market-page-header">
      {/* Sports fixtures show only the deepest category, inside the scoreboard panel. */}
      {categories && categories.length > 0 && !isSportsEvent(question) && (
        <CategoryList categories={categories} />
      )}
      <QuestionHeader
        question={question}
        inMarketPage
        categories={categories}
        isRealMoney={isRealMoney}
        locale={locale}
        usesButtonsDisplay={usesButtonsDisplay(question)}
        showBrierScore={showSummary && question.complete}
        footer={<QuestionFooter question={question} inMarketPage compact={isSportsEvent(question)} />}
        shareFollow={<MarketShareFollow question={question} inMarketPage />}
      />
    </div>
  )
}

export default MarketPageHeader
